module.exports = __webpack_public_path__ + "static/media/tron.6df1902e.png";